import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid, Mascaras, formataCNPJ } from './../app.config';
import { Fabricante } from './fabricante.model';
import { NTECH_API } from '../app.api';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-fabricante',
  templateUrl: './fabricante.component.html',
  styleUrls: ['./fabricante.component.css']
})
export class FabricanteComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  listaFabricante: CustomStore;
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  colunasGridFabricante = [
    {
      dataField: 'Id',
      dataType: 'string',
      caption: 'ID',
      editorOptions: { disabled: true }
    },
    {
      dataField: 'Nome',
      dataType: 'string',
      caption: 'Nome',
      validationRules: [{
        type: 'required',
        message: 'Nome é obrigatório.'
      }]
    },
    {
      dataField: 'Cnpj',
      dataType: 'string',
      caption: 'Cnpj',
      validationRules: [{
        type: 'required',
        message: 'Cnpj é obrigatório.'
      }],
      editorOptions: { mask: Mascaras.Cnpj },
      customizeText: formataCNPJ
    }
  ];

  editOptionsGridFabricante = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Fabricante',
      showTitle: true
    }
  };

  constructor(@Inject(Http) http: Http) {
    this.listaFabricante = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/fabricante/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/fabricante/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/fabricante/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/fabricante/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

}



// WEBPACK FOOTER //
// ./src/app/fabricante/fabricante.component.ts